import React, { useEffect } from "react";
import { connect, useSelector } from "react-redux";
import { useSnackbar } from "notistack";

import { MapDispatchToProps, MapStateToProps, MergedProps, P_Props } from "./Notifier.type";
import { AppState, RootState } from "../../../models";
import { bindActionCreators, Dispatch } from "redux";
import { NotificationActions } from "../../../store/actions";
import { Button } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

const NotifierPresenter: React.FC<MergedProps> = (props) => {
  const notifications: AppState.AppNotifications = useSelector((store: RootState) => store.notifications || []);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  useEffect(() => {
    notifications.list.forEach((noti) => {
      enqueueSnackbar(noti.message, {
        preventDuplicate: true,
        key: noti.id,
        variant: noti.type,
        action: (key) => {
          return (
            <Button
              onClick={() => {
                closeSnackbar(key);
                props.actions.removeSnackbar(noti.id);
              }}
            >
              <CloseIcon style={{ fontSize: "2.2rem", color: "#fff" }} />
            </Button>
          );
        },
        onExited: (event, myKey) => {
          props.actions.removeSnackbar(myKey as string);
        },
      });
    });
    // eslint-disable-next-line
  }, [notifications, closeSnackbar, enqueueSnackbar]);

  return <></>;
};

export default connect<MapStateToProps, MapDispatchToProps, P_Props, RootState>(
  (state: RootState) => ({
  }),
  (dispatch: Dispatch) => ({
    actions: bindActionCreators(Object.assign(NotificationActions), dispatch),
  })
)(NotifierPresenter);
